// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import SearchTextField from "@steiner/Overrides/Widgets/OrderHistory/SearchTextField";
import * as React from "react";

export const orderHistorySearchFieldReleaseNumberStyles: SearchTextFieldStyles = {};
const styles = orderHistorySearchFieldReleaseNumberStyles;

const OrderHistorySearchFieldReleaseNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="releasenumber"
            label="Release #"
            inputType="poNumber"
            placeholder="Enter Release #"
            testSelector="orderHistory_filterReleaseNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldReleaseNumber,
    definition: {
        group: "Order History",
        displayName: "Release Number",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
